var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "report-dashboard staffing-dashboard py-0",
      attrs: { fluid: "" }
    },
    [
      _c("DashboardFilters", { on: { input: _vm.setCriteria } }),
      _c("v-progress-linear", {
        attrs: { active: _vm.loading, color: "secondary", indeterminate: "" }
      }),
      _vm.dashboard
        ? _c(
            "div",
            {
              staticClass: "dashboard-content",
              style: { height: _vm.contentHeight }
            },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("labels.hoursAndOvertime")) +
                    "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                _vm._l(_vm.hoursTiles, function(tile) {
                  return _c(
                    "v-col",
                    { key: tile.key, attrs: { cols: "6", md: "3" } },
                    [
                      _c("DashboardTile", {
                        class: tile.key,
                        attrs: {
                          detail: tile.detail,
                          label: tile.label,
                          value: tile.value
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "7" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.hoursPerDay")) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.hoursPerDayData,
                              options: _vm.stackedBarOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "5" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c("div", { staticClass: "chart-title" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("labels.hoursBy")) +
                                    "\n            "
                                )
                              ]),
                              _c("v-spacer"),
                              _c(
                                "v-btn-toggle",
                                {
                                  staticClass: "breakdown",
                                  attrs: {
                                    color: "secondary",
                                    dense: "",
                                    mandatory: ""
                                  },
                                  model: {
                                    value: _vm.breakdown,
                                    callback: function($$v) {
                                      _vm.breakdown = $$v
                                    },
                                    expression: "breakdown"
                                  }
                                },
                                _vm._l(_vm.breakdownOptions, function(option) {
                                  return _c(
                                    "v-btn",
                                    {
                                      key: option.value,
                                      attrs: {
                                        small: "",
                                        text: "",
                                        value: option.value
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(option.text) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c("HorizontalBarChart", {
                            attrs: {
                              "chart-data": _vm.breakdownData,
                              options: _vm.horizontalStackedBarOptions,
                              styles: _vm.barChartStyles(
                                _vm.breakdownRows.length
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.mostOvertime")) +
                                "\n          "
                            )
                          ]),
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "top-overtime",
                              attrs: { dense: "" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.employeeName"))
                                    )
                                  ]),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.homeDepartment"))
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.overtimeHours")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.totalHours")) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.dashboard.hours.topOvertime,
                                    function(row) {
                                      return _c("tr", { key: row.userId }, [
                                        _c("td", [_vm._v(_vm._s(row.name))]),
                                        _c("td", [
                                          _vm._v(_vm._s(row.homeDepartmentName))
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.formatNumber(row.overtime)
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.formatNumber(row.total)
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  ),
                                  _vm.dashboard.hours.topOvertime.length === 0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "grey--text",
                                            attrs: { colspan: "4" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("labels.noOvertime")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("labels.absences")) + "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                _vm._l(_vm.absenceTiles, function(tile) {
                  return _c(
                    "v-col",
                    { key: tile.key, attrs: { cols: "6" } },
                    [
                      _c("DashboardTile", {
                        class: tile.key,
                        attrs: {
                          detail: tile.detail,
                          label: tile.label,
                          value: tile.value
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.absencesPerDay")) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.absencesPerDayData,
                              options: _vm.stackedBarOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._l(_vm.doughnutCharts, function(chart) {
                    return _c(
                      "v-col",
                      { key: chart.key, attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "v-card",
                          {
                            class: ["chart-card", chart.key],
                            attrs: { outlined: "" }
                          },
                          [
                            _c("div", { staticClass: "chart-title" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(chart.title) +
                                  "\n          "
                              )
                            ]),
                            chart.data.labels.length > 0
                              ? _c("DoughnutChart", {
                                  attrs: {
                                    "chart-data": chart.data,
                                    options: _vm.doughnutOptions,
                                    styles: _vm.chartStyles
                                  }
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass: "no-data grey--text",
                                    style: _vm.chartStyles
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("labels.noRecords")) +
                                        "\n          "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.mostAbsences")) +
                                "\n          "
                            )
                          ]),
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "top-absences",
                              attrs: { dense: "" }
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.employeeName"))
                                    )
                                  ]),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("labels.homeDepartment"))
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.callOuts")) +
                                        "\n                "
                                    )
                                  ]),
                                  _c("th", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("labels.callOutHours")) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.dashboard.absences.topAbsences,
                                    function(row) {
                                      return _c("tr", { key: row.userId }, [
                                        _c("td", [_vm._v(_vm._s(row.name))]),
                                        _c("td", [
                                          _vm._v(_vm._s(row.homeDepartmentName))
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.formatNumber(row.count)
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.formatNumber(row.hours)
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  ),
                                  _vm.dashboard.absences.topAbsences.length ===
                                  0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "grey--text",
                                            attrs: { colspan: "4" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("labels.noCallOuts")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }